import {injectable} from "inversify";
import {roundFront} from "@/modules/base/services/chance";
import {StaffMember} from "@/modules/staff/entity";

@injectable()
export class MarketValueCalculator {
  public async calculate(member: StaffMember): Promise<number> {
    return roundFront(member.skill * 100);
  }
}
